import { render, staticRenderFns } from "./MySkills.vue?vue&type=template&id=2418a670&scoped=true&"
import script from "./MySkills.vue?vue&type=script&lang=js&"
export * from "./MySkills.vue?vue&type=script&lang=js&"
import style0 from "./MySkills.vue?vue&type=style&index=0&id=2418a670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418a670",
  null
  
)

export default component.exports